import React from "react";
import { Row, Col, Image } from "react-bootstrap";
import { ButtonSocial } from "./Components/ButtonSocial";
import AppStore from "../../Components/Landing/img/LogoAppstore2.png";
import PlayStore from "../../Components/Landing/img/LogoGoogle2.png";
import AppStoreEs from "../../Components/Landing/img/app-store-es.svg";
import PlayStoreEs from "../../Components/Landing/img/google-play-es.svg";
import Lottie from "lottie-react";
import ScrollAnimation from "../../Images/scroll.json";
import "./Contact.css";

import en from "../../translate/en";
import es from "../../translate/es";

export const ContactComponent = ({ lan }) => {
  let traductions = lan === "es" ? es : en;

  return (
    <div style={{ overflow: "hidden" }}>
      <Row style={{ marginRight: 0 }}>
        <Col>
          <div className="wirebit-new">
            <Lottie
              className="scroll-animation"
              animationData={ScrollAnimation}
              loop={true}
            />
            <div className="ladding-logo">
              {/* <img className="logo"  src={require("../../Images/logo-wirebit.svg")} /> */}
              <img
                className="logoContact"
                src={require("../../Images/logo_wirebit.svg")}
              />
            </div>
            <div className="card-and-figure-container">
              <div className="float-figure-blue">
                <img
                  className="figure-sizes"
                  src={require("../../Images/forma-azul.svg")}
                />
              </div>
              <div className="float-card">
                <img
                  className="size-card"
                  src={require("../../Images/tarjeta-15dic.svg")}
                />
              </div>
            </div>
            <div className="title-wirebit-new">
              <span className="title-wbd-card">
                {traductions.contact.section_1.title}
                <br />
                {traductions.contact.section_1.title1}
              </span>
              <span className="subtitle-wbd-card">
                {traductions.contact.section_1.subtitle + " "}
                <span className="medium-bold">
                  {traductions.contact.section_1.subtitle2}
                </span>
              </span>
            </div>
            <div className="mobile-image-container">
              <div className="float-figure-cellphone">
                <img
                  className="cellphone-size"
                  src={require("../../Images/26-dic-wirebit-celular.svg")}
                />
              </div>
              <div className="float-figure-orange">
                <img
                  className="figure-sizes"
                  src={require("../../Images/forma-naranja.svg")}
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
      {/* Orange Section */}
      <Row style={{ marginRight: 0 }}>
        <Col sm={12} style={{ padding: 0 }}>
          <div className="help-section">
            <Row className="margin-help">
              <Col sm={12} style={{ textAlign: "center" }}>
                <span className="title-help-section">
                  {traductions.contact.section_2.help_text}
                </span>
              </Col>
              {/* <Col sm={12} style={{textAlign: 'center'}}>
              <span className='text-help-section'>{traductions.contact.section_2.meeting_call}</span>
            </Col>
            <Col sm={12} style={{textAlign: 'center', display: 'flex', justifyContent: 'center', marginTop: '40px'}}>
              <ButtonSocial variant='meeting'/>
            </Col> */}
            </Row>
            <Row className="margin-mobile">
            <Col sm={12} style={{textAlign: 'center'}}>
              <span className='title-call-mex'>{traductions.contact.section_2.call_costumer_service}</span>
            </Col>
            <Col sm={12} style={{textAlign: 'center'}}>
              <a className='number-call-mex' href="tel:+528141702609">+52 81 4170 2609</a>
            </Col>
          </Row>
            {/* <Row className="margin-mobile">
            <Col sm={12} style={{textAlign: 'center'}}>
              <span className='title-call-mex'>{traductions.contact.section_2.call_local}</span>
            </Col>
            <Col sm={12} style={{textAlign: 'center'}} className='number-call-mex-col'>
              <span className='number-call-mex'>81 4170 2609</span>
            </Col>
          </Row> */}
          {/* <Row className="margin-mobile">
            <Col sm={12} style={{textAlign: 'center'}}>
              <span className='title-call-mex'>{traductions.contact.section_2.call_foreign}</span>
            </Col>
            <Col sm={12} style={{textAlign: 'center'}} className='number-call-mex-col'>
              <span className='number-call-mex'>+52 81 4170 2609</span>
            </Col>
          </Row> */}
            <Col sm={12} style={{ textAlign: "center", marginBottom: "7px" }}>
              <span className="send-msg-help-section">
                {traductions.contact.section_2.send_msg}
              </span>
            </Col>
            <div className="contact">
              <span id="hello" className="font-white">
                hello@wirebit.com
              </span>
              <span id="schedule" className="font-white">
                {traductions.contact.section_2.schedule}
              </span>
              <span id="time-zone" className="font-white">
                {traductions.contact.section_2.time_zone}
              </span>
            </div>
            <Row style={{ margin: "0px 0px 120px", width: "100%" }}>
              <Col
                xl={4}
                md={4}
                sm={12}
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "0px 75px",
                }}
              >
                <ButtonSocial
                  style={{ margin: 0 }}
                  variant="instagram"
                  url={"https://www.instagram.com/wirebitdigital/"}
                />
              </Col>
              <Col
                xl={4}
                md={4}
                sm={12}
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "0px 75px",
                }}
              >
                <ButtonSocial
                  style={{ margin: 0 }}
                  variant="facebook"
                  url={"https://www.facebook.com/wirebitdigital"}
                />
              </Col>
              <Col
                xl={4}
                md={4}
                sm={12}
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "0px 75px",
                }}
              >
                <ButtonSocial
                  style={{ margin: 0 }}
                  variant="linkedin"
                  url={
                    "https://www.linkedin.com/company/wirebit-oficial/mycompany/"
                  }
                />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      {/* Blue Section */}
      <div className="download-app">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "8.48px",
          }}
        >
          <img src={require("../../Images/app-wbd.svg")} />
        </div>
        <Row style={{ textAlign: "center", marginBottom: "10px" }}>
          <Col sm={12}>
            <span className="title-help-section" style={{ lineHeight: 1 }}>
              {traductions.contact.section_3.donwload_title}
              <br />
              {traductions.contact.section_3.donwload_title2}
            </span>
          </Col>
        </Row>
        <Row style={{ textAlign: "center" }}>
          <Col sm={12}>
            <p className="font-white">
              {traductions.contact.section_3.donwload_sub}
              <br />
              {traductions.contact.section_3.donwload_sub2}
              <br />
              {traductions.contact.section_3.donwload_sub3}
            </p>
          </Col>
        </Row>
        <Row
          style={{
            marginTop: 40,
            marginLeft: 0,
            marginRight: 0,
            justifyContent: "center",
          }}
        >
          <div>
            <a
              style={{ cursor: "pointer" }}
              href="https://play.google.com/store/apps/details?id=com.wirebitdigitalapp"
              target="_blank"
            >
              <Image
                src={lan === "es" ? PlayStoreEs : PlayStore}
                width={190}
                className="google-btn"
              />
            </a>
            <a
              href="https://apps.apple.com/mx/app/wirebit-digital/id1563970813"
              target="_blank"
            >
              <Image
                src={lan === "es" ? AppStoreEs : AppStore}
                width={187}
                className="apple-btn"
              />
            </a>
          </div>
        </Row>
      </div>
    </div>
  );
};
